define("shared/components/shared/post/secondary/wrapper", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@glimmer/tracking", "@ember/service", "@ember/utils", "ember-concurrency-decorators", "later/utils/constants"], function (_exports, _component, _templateFactory, _component2, _object, _tracking, _service, _utils, _emberConcurrencyDecorators, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@glimmer/tracking",0,"@ember/service",0,"@ember/utils",0,"ember-concurrency-decorators",0,"later/utils/constants",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div {{did-update this.removeSecondary @proposedMultiPostIndex}}>
    {{#if this.hashtagSuggestionsOpen}}
      <Shared::Post::Secondary::HashtagSuggestions::Wrapper
        @isCarouselPost={{@isCarouselPost}}
        @hasDirtyAttributes={{@hasDirtyAttributes}}
        @location={{@location}}
        @mediaItem={{@mediaItem}}
        @post={{@post}}
        @postMediaItems={{@postMediaItems}}
        @postElementId={{@postElementId}}
        @socialProfile={{@socialProfile}}
        @toggle={{fn @toggleSecondary this.smartHashtagsModalType @targetLocation}}
      />
    {{/if}}
  
    {{#if this.savedCaptionsOpen}}
      <Shared::Post::Secondary::SavedCaptions::Wrapper
        @location={{@location}}
        @mediaItem={{@mediaItem}}
        @post={{@post}}
        @postElementId={{@postElementId}}
        @socialProfile={{@socialProfile}}
        @toggle={{fn @toggleSecondary this.savedCaptionsModalType @targetLocation}}
        @savedCaptionToEdit={{@savedCaptionToEdit}}
        @setCaptionToEdit={{@setCaptionToEdit}}
        @exitEditingCaption={{task this.exitEditingCaption}}
      />
    {{/if}}
  </div>
  
  */
  {
    "id": "iZ7ubfgt",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"removeSecondary\"]],[30,1]],null],[12],[1,\"\\n\"],[41,[30,0,[\"hashtagSuggestionsOpen\"]],[[[1,\"    \"],[8,[39,2],null,[[\"@isCarouselPost\",\"@hasDirtyAttributes\",\"@location\",\"@mediaItem\",\"@post\",\"@postMediaItems\",\"@postElementId\",\"@socialProfile\",\"@toggle\"],[[30,2],[30,3],[30,4],[30,5],[30,6],[30,7],[30,8],[30,9],[28,[37,3],[[30,10],[30,0,[\"smartHashtagsModalType\"]],[30,11]],null]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"savedCaptionsOpen\"]],[[[1,\"    \"],[8,[39,4],null,[[\"@location\",\"@mediaItem\",\"@post\",\"@postElementId\",\"@socialProfile\",\"@toggle\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\",\"@exitEditingCaption\"],[[30,4],[30,5],[30,6],[30,8],[30,9],[28,[37,3],[[30,10],[30,0,[\"savedCaptionsModalType\"]],[30,11]],null],[30,12],[30,13],[28,[37,5],[[30,0,[\"exitEditingCaption\"]]],null]]],null],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"]],[\"@proposedMultiPostIndex\",\"@isCarouselPost\",\"@hasDirtyAttributes\",\"@location\",\"@mediaItem\",\"@post\",\"@postMediaItems\",\"@postElementId\",\"@socialProfile\",\"@toggleSecondary\",\"@targetLocation\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\"],false,[\"did-update\",\"if\",\"shared/post/secondary/hashtag-suggestions/wrapper\",\"fn\",\"shared/post/secondary/saved-captions/wrapper\",\"task\"]]",
    "moduleName": "shared/components/shared/post/secondary/wrapper.hbs",
    "isStrictMode": false
  });

  let WrapperComponent = (_class = class WrapperComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "dialogManager", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "errors", _descriptor3, this);

      _initializerDefineProperty(this, "secondaryModal", _descriptor4, this);

      _defineProperty(this, "smartHashtagsModalType", _constants.SECONDARY_MODAL_TYPES.SMART_HASHTAGS);

      _defineProperty(this, "savedCaptionsModalType", _constants.SECONDARY_MODAL_TYPES.SAVED_CAPTIONS);

      _initializerDefineProperty(this, "multiPostActiveIndex", _descriptor5, this);
    }

    get hashtagSuggestionsOpen() {
      return this.secondaryModal.isHashtagSuggestionsModalActive(this.args.postElementId);
    }

    get savedCaptionsOpen() {
      return this.secondaryModal.isSavedCaptionsModalActive(this.args.postElementId);
    }

    *exitEditingCaption() {
      var _this$args$savedCapti, _this$args$savedCapti2, _this$args$savedCapti3;

      const hasUnsavedCaption = (0, _utils.isPresent)((_this$args$savedCapti = this.args.savedCaptionToEdit) === null || _this$args$savedCapti === void 0 ? void 0 : _this$args$savedCapti.content) && (((_this$args$savedCapti2 = this.args.savedCaptionToEdit) === null || _this$args$savedCapti2 === void 0 ? void 0 : _this$args$savedCapti2.isNew) || ((_this$args$savedCapti3 = this.args.savedCaptionToEdit) === null || _this$args$savedCapti3 === void 0 ? void 0 : _this$args$savedCapti3.hasDirtyAttributes));

      if (hasUnsavedCaption) {
        const didConfirm = yield this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
          description: this.intl.t('shared_phrases.changes_not_saved'),
          confirmButton: this.intl.t('shared_words.leave')
        });

        if (!didConfirm) {
          return;
        }
      }

      this.args.rollbackSavedCaption();
    }

    async removeSecondary() {
      try {
        if (this.args.proposedMultiPostIndex !== this.multiPostActiveIndex) {
          if (this.savedCaptionsOpen) {
            await this.exitEditingCaption.perform();
          }

          this.multiPostActiveIndex = this.args.proposedMultiPostIndex;
          return this.secondaryModal.removeModal(this.args.postElementId);
        }
      } catch (error) {
        if (error) {
          this.errors.log(error);
        }
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "multiPostActiveIndex", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return this.args.proposedMultiPostIndex;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "exitEditingCaption", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "exitEditingCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeSecondary", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeSecondary"), _class.prototype)), _class);
  _exports.default = WrapperComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WrapperComponent);
});